/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SoftwareEnvironmentBuildStateEnum } from './SoftwareEnvironmentBuildStateEnum';
import {
    SoftwareEnvironmentBuildStateEnumFromJSON,
    SoftwareEnvironmentBuildStateEnumFromJSONTyped,
    SoftwareEnvironmentBuildStateEnumToJSON,
} from './SoftwareEnvironmentBuildStateEnum';

/**
 * 
 * @export
 * @interface SoftwareEnvironmentLatestBuildSchema
 */
export interface SoftwareEnvironmentLatestBuildSchema {
    /**
     * 
     * @type {number}
     * @memberof SoftwareEnvironmentLatestBuildSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof SoftwareEnvironmentLatestBuildSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof SoftwareEnvironmentLatestBuildSchema
     */
    updated: Date;
    /**
     * 
     * @type {SoftwareEnvironmentBuildStateEnum}
     * @memberof SoftwareEnvironmentLatestBuildSchema
     */
    state: SoftwareEnvironmentBuildStateEnum;
    /**
     * 
     * @type {string}
     * @memberof SoftwareEnvironmentLatestBuildSchema
     */
    reason: string;
}

/**
 * Check if a given object implements the SoftwareEnvironmentLatestBuildSchema interface.
 */
export function instanceOfSoftwareEnvironmentLatestBuildSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function SoftwareEnvironmentLatestBuildSchemaFromJSON(json: any): SoftwareEnvironmentLatestBuildSchema {
    return SoftwareEnvironmentLatestBuildSchemaFromJSONTyped(json, false);
}

export function SoftwareEnvironmentLatestBuildSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SoftwareEnvironmentLatestBuildSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'state': SoftwareEnvironmentBuildStateEnumFromJSON(json['state']),
        'reason': json['reason'],
    };
}

export function SoftwareEnvironmentLatestBuildSchemaToJSON(value?: SoftwareEnvironmentLatestBuildSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'state': SoftwareEnvironmentBuildStateEnumToJSON(value.state),
        'reason': value.reason,
    };
}

